import { apiInstance, handleApiError } from "./InstanceApi";

export const searchPrompts = async (params) => {
  try {
    const response = await apiInstance.get("/prompts/search", {
      params: params
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPromptsData = async (params) => {
  try {
    const response = await apiInstance.get("/prompts/search", {
      params: params
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deletePromptsById = async (id) => {
  try {
    const response = await apiInstance.delete(`/prompts/${id}`);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createPrompts = async (data) => {
  try {
    const response = await apiInstance.post("/prompts", data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updatePrompts = async (id, data) => {
  try {
    const response = await apiInstance.put(`/prompts/${id}`, data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const importPromptsFile = async (formData) => {
  try {
    const response = await apiInstance.post("/prompts/import", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};
